<template>
  <div class="fill-height d-flex flex-column">
    <div>
      <v-container fluid class="px-8 py-0">
        <v-row class="mt-4 mb-2">
          <v-col>
            <h2
              v-if="title"
              class="text-h3 navy--text text--darken-1 font-weight-bold"
              v-text="title"
            />
          </v-col>
          <v-col class="d-flex align-center justify-end">
            <v-btn
              v-if="showSaveDraft"
              text
              small
              class="navy--text text--darken-1"
              :disabled="!_changed"
              @click="onSaveClick"
            >
              <img
                class="mr-2"
                :src="require('@/assets/ico-save-blue.svg')"
                alt=""
              />
              Uložit jako rozepsané
            </v-btn>
          </v-col>
        </v-row>

        <slot />
      </v-container>
    </div>
    <div class="mt-auto pt-6">
      <v-container fluid class="px-8">
        <slot name="footer">
          <ButtonBarWizard
            :prev="prev"
            :next="next"
            :next-disabled="nextDisabled"
            @next="onNext"
          >
            <template #left-append>
              <slot name="navigation-left-append" />
            </template>
            <template #right-prepend>
              <slot name="navigation-right-prepend" />
            </template>
          </ButtonBarWizard>
        </slot>
      </v-container>
    </div>

    <save-audience-dialog
      v-model="audienceName"
      :opened.sync="saveAudienceDialog"
      @confirm="onSaveClick()"
    ></save-audience-dialog>
  </div>
</template>

<script>
import { call, get, sync } from "vuex-pathify"

import ButtonBarWizard from "@/components/ui/buttonBars/ButtonBarWizard"
import SaveAudienceDialog from "@/components/ui/modals/SaveAudienceDialog"
import Toastification from "../../../ui/Toastification"

export default {
  components: {
    ButtonBarWizard,
    SaveAudienceDialog,
  },
  props: {
    title: {
      type: String,
      required: false,
    },
    showSaveDraft: {
      type: Boolean,
      default: true,
    },
    prev: {
      type: String,
      default: null,
    },
    next: {
      type: [String, Boolean],
      default: null,
    },
    nextDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      saveAudienceDialog: false,
    }
  },
  computed: {
    ...get("audiences@model", ["_changed"]),
    ...sync("audiences/model@audience", {
      audienceName: "name",
    }),
  },
  methods: {
    ...call("audiences", ["saveAudienceDraft"]),
    onSaveClick() {
      if (!this.audienceName) {
        this.saveAudienceDialog = true

        return false
      }

      this.saveAudienceDraft().then(() => {
        this.$toast.success({
          component: Toastification,
          props: {
            title: "Publikum uloženo",
            text: "Vaše publikum bylo úspěšně uloženo",
          },
        })
      })
    },
    onNext() {
      this.$emit("next")
    },
  },
}
</script>
